// Bungkus sebuah promise supaya nggak nunggu selamanya kalau network lambat/gagal.
// Kalau promise belum selesai dalam `ms` milidetik, langsung resolve ke `fallback`
// (dan promise asli tetap boleh lanjut di background, cuma nggak ditunggu lagi).
export function withTimeout(promise, ms = 6000, fallback = null) {
  return Promise.race([
    promise.catch((err) => { console.error(err); return fallback; }),
    new Promise((resolve) => setTimeout(() => resolve(fallback), ms)),
  ]);
}
